import React, { useState } from 'react';
import { Button, ButtonGroup, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import RefreshIcon from '@mui/icons-material/Refresh';
import { selectCueNotesList } from '../store/Tasks.selectors';
import { useSelector } from 'react-redux';

const PlacementContainerStyles = makeStyles()(theme => ({
  buttonTitle: {
    textAlign: 'left',
    font: 'normal normal normal 13px/20px Roboto',
    color: '#555555',
    opacity: '1',
    width: '100%',
    letterSpacing: '0',
    textTransform: 'none',
  },
  buttonTitleOnClick: {
    textAlign: 'left',
    font: 'normal normal normal 13px/20px Roboto',
    color: '#FFFFFF',
    opacity: '1',
    width: '100%',
    fontWeight: 'inherit',
    letterSpacing: '0',
    textTransform: 'none',
  },
  internalButton: {
    width: '64px',
    height: '36px',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    opacity: '1',
    padding: '10px 5px',
  },
  internalButtonOnClick: {
    width: '64px',
    height: '36px',
    background: `${theme.palette.components.button.secondary.backgroundColor} 0% 0% no-repeat padding-box`,
    opacity: '1',
    padding: '10px 5px',
    '&:hover': {
      background: theme.palette.components.button.secondary.backgroundColor,
    },
  },
  //
  externalButton: {
    width: '82px',
    height: '36px',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    opacity: '1',
    padding: '10px 5px',
  },
  externalButtonOnClick: {
    width: '82px',
    height: '36px',
    background: `${theme.palette.components.button.secondary.backgroundColor} 0% 0% no-repeat padding-box`,
    opacity: '1',
    padding: '10px 5px',
    '&:hover': {
      background: theme.palette.components.button.secondary.backgroundColor,
    },
  },
  tooltipArrow: {
    color: theme.palette.framework.system.white,
    '&::before': {
      border: `1px solid ${theme.palette.framework.system.doveGray}`,
    },
  },
  tooltipBackground: {
    backgroundColor: theme.palette.framework.system.white,
    color: theme.palette.framework.system.doveGray,
    border: `1px solid ${theme.palette.framework.system.doveGray}`,
    fontSize: '12px',
  },
  tooltip: {
    margin: '6px 2px 2px 10px',
  },
}));

export const CueButtonGroup = props => {
  const cuedToMe = 'CuedToMe';
  const allCues = 'AllCues';
  const { setShowMyCues, isFilterApplied, setIsFilterApplied, getCueNotes, setLastCueNoteId } = props;
  const cueNotesList = useSelector(selectCueNotesList);
  const [currentTab, setCurrentTab] = useState(allCues);
  const { classes, cx } = PlacementContainerStyles();
  const { t } = useTranslation();

  const changeStyle = tab => {
    if (isFilterApplied) {
      setIsFilterApplied(false);
    }
    setCurrentTab(tab);
    if (tab === allCues) {
      setShowMyCues(false);
    } else {
      setShowMyCues(true);
    }
  };

  const handleRefresh = () => {
    getCueNotes?.();
    setLastCueNoteId(cueNotesList?.length > 0 ? cueNotesList[cueNotesList.length - 1]?.taskId : null);
  };

  return (
    <>
      <ButtonGroup>
        <Button
          onClick={() => {
            return changeStyle(allCues);
          }}
          className={cx({
            [classes.internalButtonOnClick]: currentTab === allCues && isFilterApplied === false,
            [classes.internalButton]: currentTab !== allCues || isFilterApplied === true,
          })}
        >
          <div
            className={cx({
              [classes.buttonTitleOnClick]: currentTab === allCues && isFilterApplied === false,
              [classes.buttonTitle]: currentTab !== allCues || isFilterApplied === true,
            })}
          >
            {t('notification.taskSidePanel.cueNotes.allCues')}
          </div>
        </Button>
        <Button
          onClick={() => {
            return changeStyle(cuedToMe);
          }}
          className={cx({
            [classes.externalButtonOnClick]: currentTab === cuedToMe && isFilterApplied === false,
            [classes.externalButton]: currentTab !== cuedToMe || isFilterApplied === true,
          })}
        >
          <div
            className={cx({
              [classes.buttonTitleOnClick]: currentTab === cuedToMe && isFilterApplied === false,
              [classes.buttonTitle]: currentTab !== cuedToMe || isFilterApplied === true,
            })}
          >
            {t('notification.taskSidePanel.cueNotes.cuedToMe')}
          </div>
        </Button>
      </ButtonGroup>
      <div className={classes.tooltip}>
        <Tooltip
          classes={{
            tooltip: classes.tooltipBackground,
            arrow: classes.tooltipArrow,
          }}
          arrow
          title={t('notification.taskSidePanel.cueNotes.refreshCue')}
        >
          <RefreshIcon onClick={handleRefresh} />
        </Tooltip>
      </div>
    </>
  );
};
